var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"has-text-centered"},[_c('img',{staticClass:"error404",attrs:{"src":_vm.error404,"alt":""}}),_c('h1',{staticClass:"title"},[_vm._v("Página não encontrada!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }